// src/app/meter/components/meter-list/meter-health/meter-health.component.ts

import { Component, OnInit, OnDestroy } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MeterAbstractService } from '../../../services/meter.abstract.service';
import { MeterItem } from '../../../models/meter-manage.model';

@Component({
    selector: 'app-meter-health',
    templateUrl: './meter-health.component.html',
    styleUrls: ['./meter-health.component.scss'],
})
export class MeterHealthComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    displayedColumns: string[] = ['nodeId', 'address', 'users', 'lastMeterReadAt', 'daysSilent'];
    meters: MeterItem[] = [];
    total = 0;
    pageSize = 20;
    pageIndex = 0;
    loading = false;

    silentDays = 7;

    constructor(private meterService: MeterAbstractService) {}

    ngOnInit(): void {
        this.loadHealth();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onPageChange(event: PageEvent): void {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.loadHealth();
    }

    formatAddress(meter: MeterItem): string {
        const parts = [meter.address.street];
        if (meter.address.unit) {
            parts.push(`Unit ${meter.address.unit}`);
        }
        parts.push(meter.address.postCode);
        return parts.join(', ');
    }

    getDaysSilent(meter: MeterItem): string | number {
        if (!meter.lastMeterReadAt) {
            return '∞';
        }
        const last = new Date(meter.lastMeterReadAt);
        const now = new Date();
        const diffMs = now.getTime() - last.getTime();
        return Math.floor(diffMs / (1000 * 60 * 60 * 24));
    }

    private loadHealth(): void {
        this.loading = true;
        this.meterService
            .getHealth({
                page: this.pageIndex + 1,
                limit: this.pageSize,
                silentDays: this.silentDays,
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (result) => {
                    this.meters = result.data;
                    this.total = result.total;
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });
    }
}
